import type { ModuleId } from '@mentimeter/http-clients';
import { memo } from 'react';
import type { IconProps } from '@mentimeter/ragnar-visuals/slide-type-icons';
import { getSlideTypeIconFromModuleId } from './getSlideTypeIconFromModuleId';

interface Props extends IconProps {
  moduleId: ModuleId;
}

export const Icon = memo<Props>(({ moduleId, ...props }: Props) => {
  const Icon = getSlideTypeIconFromModuleId(moduleId);

  if (!Icon) {
    return null;
  }

  return <Icon {...props} />;
});
